import { z } from "zod";
export const MediaProviderSchema = z.nativeEnum({
    YOUTUBE: "youtube",
    SANITY: "sanity",
    DDRAGON: "ddragon",
    WEB: "web",
});
export const MediaProvider = MediaProviderSchema.enum;
export const MediaTypeSchema = z.nativeEnum({
    IMAGE: "image",
    VIDEO: "video",
    AUDIO: "audio",
});
export const MediaType = MediaTypeSchema.enum;
export const FocalPointSchema = z.nativeEnum({
    LEFT: "left",
    RIGHT: "right",
    TOP: "top",
    BOTTOM: "bottom",
    CENTER: "center",
});
export const FocalPoint = FocalPointSchema.enum;
export const DimensionsSchema = z.object({
    width: z.number(),
    height: z.number(),
});
export const ImageColorsSchema = z.object({
    primary: z.string(),
    secondary: z.string(),
    label: z.string(),
});
export const ImageMediaSchema = z.object({
    type: z.literal(MediaType.IMAGE),
    provider: MediaProviderSchema,
    url: z.string(),
    accessibilityText: z.string().optional(),
    focalPoint: FocalPointSchema.optional(),
    dimensions: DimensionsSchema.optional(),
    colors: ImageColorsSchema.optional(),
});
export const BaseVideoMediaSchema = z.object({
    type: z.literal(MediaType.VIDEO),
    provider: MediaProviderSchema,
    thumbnail: ImageMediaSchema.optional(),
    dimensions: DimensionsSchema,
    duration: z.number().optional(),
});
export const YoutubeVideoMediaSchema = BaseVideoMediaSchema.extend({
    provider: z.literal("youtube"),
    youtubeId: z.string(),
});
export const MediaSourceSchema = z.object({
    src: z.string(),
    type: z.string(),
});
export const EmbeddedVideoMediaSchema = BaseVideoMediaSchema.extend({
    provider: z.enum(["sanity", "bynder", "ddragon", "web"]),
    sources: z.array(MediaSourceSchema),
});
export const VideoMediaSchema = z.discriminatedUnion("provider", [YoutubeVideoMediaSchema, EmbeddedVideoMediaSchema]);
export const AudioMediaSchema = z.object({
    type: z.literal(MediaType.AUDIO),
    provider: MediaProviderSchema,
    accessibilityText: z.string().optional(),
    sources: z.array(MediaSourceSchema),
});
export const MediaSchema = z.union([ImageMediaSchema, VideoMediaSchema, AudioMediaSchema]);
export const VisualMediaSchema = z.union([ImageMediaSchema, VideoMediaSchema]);
//# sourceMappingURL=index.js.map